export const routePaths = {
  SignIn: '/',
  SignUp: '/signup',
  Dashboard: '/dashboard',
  People: '/people',
  Favorites: '/favorites',
  FamilyTree: '/family-tree',
  Memories: '/memories',
  Recipes: '/recipes',
  Sharing: '/sharing',
  Storages: '/storage',
  Trash: '/trash',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  TwoFactorAuthentication: '/two-factor-authentication',
  Subscription: '/subscription',
  SelectedSubscription: '/selected-subscription',
  PaymentSuccess: '/payment-success',
  MyProfile: '/my-profile',
  EditProfile: '/my-profile/edit',
  Camera: '/my-profile/camera',
  SecurityPrivacy: '/settings/security-privacy',
  Payments: '/payments',
  Notification: '/settings/notification',
  Help: '/settings/help',
  ManageSubscriptions: '/settings/subscriptions/manage',
  SettingSubscription: '/settings/subscriptions',
  ContributorStorage: '/settings/subscriptions/manage/photos',
  Photos: '/photos',
  MediaView: '/photos/media',
  TakeAPhoto: '/photos/camera',
  PaymentsSettings: '/settings/payments',
  Storage: '/settings/storage',
  Folders: '/photo/folders',
  Friends: '/people/friends',
  Family: '/people/family',
  RecipeFolders: '/recipes/folder',
  FavoriteViewAll: '/favorites/view',
  TrashViewAll: '/trash/view',
  ResetPasswordRequest: '/reset-password/request',
  PendingContributions: '/photos/contributions',
  SharingGroupDetail: '/sharing/groups',
  PrivacyPolicy: '/privacy-policy',
  TermsAndConditions: '/terms-and-conditions'
};
